/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-04 14:16:03
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2021-01-27 13:24:32
 */

import React, { PureComponent } from 'react';
import { Row, Col, Select, Carousel, Button, Collapse, Modal } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { AppWrappperHOC } from '../../Root/HOC';
import Journey from '../../../containers/NewLanding/Journey';
import endPoints from '../../../config/endPoints';
import { CAREER_CONSTANTS } from '../constants';
import { metaTags, constants } from '../../../devUtils';
import { HelmetWrapper, LandingContainer, SubTitle } from '../../../components';

const { Option } = Select;
const { Panel } = Collapse;

const StyledCareers = styled.section`
  .image-grayscale{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  ${SubTitle} {
    line-height: 28px;
  }
  .left-filter{
    ul{
      list-style-type: none;
      li{
        cursor: pointer;
        color: ${({ theme }) => theme.LandingBlack};
        margin-bottom: 10px;
        &.active{
          color: ${({ theme }) => theme.primaryColor};
        }
      }
    }
  }
  .about-us-values{
    .grey-bg{
      background: ${({ theme }) => theme.tintGray};
      height: 210px;
      padding: 25px 40px;
      border-radius: 10px;
    }
    .white-bg{
      background: ${({ theme }) => theme.whiteColor};
      height: 210px;
      padding: 25px 40px;
      border-radius: 10px;
    }
  }
  .bg-gradient{
    background-image: linear-gradient( #FFFFFF 60%, #EAECF4 40%) !important;
  }
  .slick-dots{
    height: auto;
    bottom: 18rem;
    left: -2rem;
    text-align: right;
    li{
      background: ${({ theme }) => theme.transparentColor};
      border:${({ theme }) => theme.lightGray} solid 1px;
      width:14px;
      height:14px;
      border-radius:50%;
      cursor:pointer;
      &.slick-active{
        background: ${({ theme }) => theme.transparentColor};
        border:none;
        button{
          background: ${({ theme }) => theme.primaryColor};
          width:14px;
          height:14px;
          border: 4px solid ${({ theme }) => theme.secondaryColor};
          border-radius: 50%;
          &:before{
          color: ${({ theme }) => theme.transparentColor};
        }
        }
      }
      button{
          height:10px;
          &:before{
          color: ${({ theme }) => theme.transparentColor};
        }
      }
    }
  }
  .careers{
    a{
      color: ${({ theme }) => theme.secondaryColor};
    }
  }
  .ant-collapse{
    border: none;
  }
  .active-copy-link{
    color: ${({ theme }) => theme.primaryColor};
  }
  div.active-copy-link:active{
    text-decoration: underline;
  }
`;

class Career extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: undefined,
      selectedCategory: undefined,
    };
    this.stateLessKeys = {
      metaTitle: '',
      metaDescrption: '',
    };
    const { history: { location } } = props;
    if (location.search) {
      const job_id = `${location.search}`.split('=')[1].split('-').join('_');
      this.stateLessKeys.metaTitle = metaTags[constants.LINK_CAREERS][`title_${job_id}`];
      this.stateLessKeys.metaDescrption = metaTags[constants.LINK_CAREERS][`desc_${job_id}`];
    }
    this.copyJobLink = this.copyJobLink.bind(this);
  }

  componentDidMount() {
    const { history: { location } } = this.props;
    if (location.search) {
      document.getElementById(location.search).scrollIntoView();
      window.scroll(0, window.scrollY - 55);
    }
  }

  copyJobLink(evt, slug, title) {
    evt.stopPropagation();
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    const path = `${window.location.href}`.split('?')[0];
    dummy.value = `${path}?job_id=${slug}`;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    const modal = Modal.success({
      content: `Job link copied for
      ${title.split(',')[0]}`,
    });
    setTimeout(() => {
      modal.destroy();
    }, 2000);
  }

  render() {
    const { selectedLocation, selectedCategory } = this.state;
    const { history: { location } = {} } = this.props;
    return (
      <StyledCareers>
        <HelmetWrapper location={location} />
        <div className="gray-greadient">
          <section className="padding-tb-5">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={24} lg={11} xl={11} className="padding-t-3">
                  <p>Company</p>
                  <h1>Careers</h1>
                  <p className="padding-r-2">
                  Find your dream job at Zaggle and build exceptional products with us. With Zaggle take your career to new heights by becoming a part of amazing teams who think  like entrepreneurs.
                  </p>
                  <Button
                    onClick={() => window.scroll(0, 1800)}
                    className="btn red-btn margin-t-1"
                  >
                    See All Openings
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <img
                    src={endPoints.CAREERS_LANDING_IMAGE.URL}
                    alt={endPoints.CAREERS_LANDING_IMAGE.ALT}
                    className="width-100 image-grayscale"
                  />
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <section className="padding-tb-3 bg-gradient">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                  <SubTitle fontWeight="900" className="font-18">Join Our Team</SubTitle>
                  <p>We nourish our relationship with employees with regular team bonding activities and events.</p>
                </Col>
              </Row>
              <section className="padding-tb-2">
                <Carousel effect="scrollx">
                  <Row align="middle" type="flex" justify="space-around" gutter={8}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_ONE_NEW.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_ONE_NEW.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_TWO.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_TWO.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_THREE_NEW.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_THREE_NEW.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex" justify="space-around" gutter={8}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_FOUR.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_FOUR.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_FIVE.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_FIVE.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_SIX.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_SIX.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex" justify="space-around" gutter={8}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_SEVEN.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_SEVEN.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_EIGHT.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_EIGHT.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_NINE.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_NINE.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex" justify="space-around" gutter={8}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_TEN.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_TEN.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_ELVEN.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_ELVEN.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <div className="image-grayscale" >
                        <img
                          src={endPoints.CAREERS_CAROUSEL_IMAGE_TWELVE.URL}
                          alt={endPoints.CAREERS_CAROUSEL_IMAGE_TWELVE.ALT}
                          className="width-100"
                        />
                      </div>
                    </Col>
                  </Row>
                </Carousel>
              </section>
            </LandingContainer>
          </section>
          <section className="padding-tb-5 about-us-values">
            <LandingContainer>
              <Row align="top" type="flex" justify="start">
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <SubTitle fontWeight="900" className="font-22">Benefits</SubTitle>
                  <p>Reinvent your career with greater opportunities at Zaggle and enjoy various employee benefits.</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <div className="grey-bg">
                      <SubTitle fontWeight="900" className="font-20">Monthly rewards and incentives</SubTitle>
                      <p>We at Zaggle always recognize the extra efforts and dedication of employees through monthly rewards and incentives.</p>
                    </div>
                    <div className="white-bg">
                      <SubTitle fontWeight="900" className="font-20">Career benefits</SubTitle>
                      <p>We help our team members to extend their capabilities and provide exceptional growth in their career.</p>
                    </div>
                    <div className="grey-bg">
                      <SubTitle fontWeight="900" className="font-20">Friendly learning environment</SubTitle>
                      <p>We surround ourselves with people who constantly raise the bar in everything they do, who demand more from themselves and everyone around them.</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <div className="white-bg">
                      <SubTitle fontWeight="900" className="font-20">Health benefits</SubTitle>
                      <p>We keep the health of our employees at first and provide complete medical insurance and health coverage for them and their families.</p>
                    </div>
                    <div className="grey-bg">
                      <SubTitle fontWeight="900" className="font-20">Transparency</SubTitle>
                      <p>We keep all the information accessible at all levels for fast decision making and easy movement.</p>
                    </div>
                    <div className="white-bg">
                      <SubTitle fontWeight="900" className="font-20">Competitive salaries</SubTitle>
                      <p>We follow a standard salary structure and compensate each employee without any discrimination.</p>
                    </div>
                  </Col>
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <section className="padding-tb-4 gray-bg">
            <LandingContainer>
              <Row align="bottom" type="flex" justify="start">
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                  <p>Opportunities</p>
                  <SubTitle fontWeight="900" className="font-26 nomargin">Small teams, and global mission</SubTitle>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-right">
                  <Select
                    className="width-100"
                    placeholder="All locations"
                    value={selectedLocation}
                    onChange={(value) => this.setState({ selectedLocation: value })}
                  >
                    {CAREER_CONSTANTS.LOCATIONS_OPENINGS.map((item, index) => (<Option value={item} key={index}>{item || 'All'}</Option>))}
                  </Select>
                </Col>
              </Row>
              <Row align="top" type="flex" justify="start" className="padding-t-4">
                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="left-filter">
                  <ul>
                    {CAREER_CONSTANTS.CATEGORY_OPENINGS.map((item, index) => (
                      <li key={index} className={selectedCategory === item ? 'active' : undefined} onClick={() => this.setState({ selectedCategory: item })} role="presentation">
                        {item || 'All Departments'}
                      </li>))}
                  </ul>
                </Col>
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                  <Collapse accordion defaultActiveKey={window.location.search}>
                    {CAREER_CONSTANTS.CAREER_OPENING_SALES
                      .filter(({ location }) => selectedLocation ? location.includes(selectedLocation) : true)
                      .filter(({ category }) => selectedCategory ? selectedCategory === category : true)
                      .map(({ title, description, slug }) => (
                        <Panel
                          header={title}
                          extra={<div className="active-copy-link" onClick={(evt) => this.copyJobLink(evt, slug, title)} role="presentation">Copy Link</div>}
                          key={`?job_id=${slug}`}
                          className="careers"
                          id={`?job_id=${slug}`}
                        >
                          <div dangerouslySetInnerHTML={{ __html: description }} />
                        </Panel>
                      ))}
                  </Collapse>
                </Col>
              </Row>
            </LandingContainer>
          </section>
        </div>
        <Journey />
      </StyledCareers>
    );
  }
}

Career.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({}),
  }).isRequired,
};

const component = AppWrappperHOC(Career);

export { Career };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Career/index.js